import pdfMake from "pdfmake/build/pdfmake";
// import pdfFonts from "pdfmake/build/vfs_fonts";
import headerPortraitImage from '../../assets/header-portrait.png';
import footerPortraitImage from '../../assets/footer-portrait.png';

export async function generateComplianceMatrixPDF(complianceMatrixData, complianceMatrixDetailsData) {
    const [headerBase64, footerBase64] = await Promise.all([
      getBase64Image(headerPortraitImage),
      getBase64Image(footerPortraitImage),
    ]);

    // Collect all institutes from table rows
    const institutesInRows = complianceMatrixDetailsData.map(d => d.institutes);

    // Get signatories for included institutes
    const signatories = getInstituteSignatories(institutesInRows);

    const arrayOfDetails = complianceMatrixDetailsData.map(details => {
        return [
            { text: details.concerns || '', alignment: 'center', margin: [5, 5, 5, 5], fontSize: 10,},
            { text: details.institutes || '', alignment: 'center', margin: [5, 5, 5, 5], fontSize: 10,},
            { text: details.recommendations || '', alignment: 'center', margin: [5, 5, 5, 5], fontSize: 10,},
            { text: details.agreement || '', alignment: 'center', margin: [5, 5, 5, 5], fontSize: 10,},
            { text: details.date_complied || '', alignment: 'center', margin: [5, 5, 5, 5], fontSize: 10,},
            { text: details.remarks || '', alignment: 'center', margin: [5, 5, 5, 5], fontSize: 10,},
        ];
    });

    const pageSize = { width: 612, height: 936 };

    const docDefinition = {
        defaultStyle: { font: "ArialNarrow" },
        pageSize: pageSize,
        info: {
            title: 'Compliance Matrix for ' + complianceMatrixData.agenda,
        },
        pageOrientation: 'portrait',
        pageMargins: [35, 120, 35, 100],
        header: (currentPage, pageCount, pageSize) => {
            return {
                stack: [
                  {
                        image: headerBase64,
                        width: pageSize.width - 30,
                        alignment: 'center',
                        margin: [0, 10, 0, 0]
                  },
                  {
                    columns: [
                      { text: '', width: '*' }, // spacer to push box right
                      {
                        width: 'auto',
                        table: {
                          widths: ['auto'],
                          body: [
                            [
                              {
                                text: 'DNSC-FM-VPAA-001 Rev. 01 (08.19.2026)',
                                color: 'white',
                                bold: true,
                                fontSize: 9,
                                fillColor: '#000000',
                                margin: [8, 4, 8, 4]
                              }
                            ]
                          ]
                        },
                        layout: 'noBorders'
                      }
                    ],
                    margin: [0, 0, 14, 0]
                  },
                  {
                        text: 'Office of the Vice President for Academic Affairs',
                        fontSize: 16,
                        bold: true,
                        alignment: 'center',
                        font: "CenturySchoolBook"
                    }
                ]
            };
        },
        footer: {
            image: footerBase64,
            width: pageSize.width - 30,
            alignment: 'center',
            margin: [0, 25, 0, 0]
        },
        content: [
            { text: 'AMS Form 1. Recommendation and Compliance Matrix', style: 'header', alignment: 'center', margin: [0, 10, 0, 0], bold: true, fontSize: 14},
            {
              text: [
                { text: "Date of Monitoring: ", bold: true },
                { text: formatDate(complianceMatrixData.monitoring_date) },
              ],
              style: "subheader",
              margin: [0, 15, 0, 4],
            },
            {
              text: [
                { text: "Agenda: ", bold: true },
                { text: complianceMatrixData.agenda },
              ],
              style: "subheader",
              margin: [0, 0, 10, 10],
            },
            {   
              table: {
                  headerRows: 1,
                  widths: [80, 80, 105, 105, 60, 60],
                  dontBreakRows: true,
                  body: [
                      [ 
                        {text: 'Concerns/Issues', bold: true, alignment: 'center', margin: [5, 5, 5, 5], fontSize: 11 },
                        {text: 'Institutes', bold: true, alignment: 'center', margin: [5, 5, 5, 5], fontSize: 11 },
                        {text: 'Recommendations/Actions', bold: true, alignment: 'center', margin: [5, 5, 5, 5], fontSize: 11 },
                        {text: 'Compliance/Agreement', bold: true, alignment: 'center', margin: [5, 5, 5, 5], fontSize: 11 },
                        {text: 'Date Complied', bold: true, alignment: 'center', margin: [5, 5, 5, 5], fontSize: 11 },
                        {text: 'Remarks', bold: true, alignment: 'center', margin: [5, 5, 5, 5], fontSize: 11 },
                      ],
                      ...arrayOfDetails
                  ],
              },
              layout: {
                  hLineWidth: () => 0.1,
                  vLineWidth: () => 0.1,
              }
            },
            {
              pageBreak: 'avoid',
              table: {
                widths: ['60%', '40%'],
                dontBreakRows: true,
                body: [
                  [
                    {
                      stack: [
                        { text: 'Prepared by:', bold: true, margin: [0, 30, 0, 5] },
                        { text: 'GIRLEY S. GUMANAO', bold: true, decoration: 'underline', margin: [0, 20, 0, 0] },
                        { text: 'Vice President for Academic Affairs', margin: [0, 2, 0, 0] }
                      ]
                    },
                    {
                      stack: [
                        { text: 'Conformed:', bold: true, margin: [0, 30, 0, 5] },
                        ...signatories.map(s => [
                          { text: s.name, bold: true, decoration: 'underline', margin: [0, 20, 0, 0] },
                          { text: s.title, margin: [0, 2, 0, 0] }
                        ]).flat()
                      ]
                    }
                  ]
                ]
              },
              layout: {
                hLineWidth: () => 0,
                vLineWidth: () => 0
              }
            }
        ]
    };

    pdfMake.createPdf(docDefinition).open();
}

function formatDate(date) {
  if (!date) return "";
  const d = new Date(date);
  return d.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

function getInstituteSignatories(institutesInRows) {
  const signatoryMap = {
    IC: { name: 'MARK VAN M. BULADACO', title: 'Unit Head Concerned' },
    ILEGG: { name: 'FLORIE ANN L. FERMIL', title: 'Unit Head Concerned' },
    ITEd: { name: 'ARNOLD M. DUPING', title: 'Unit Head Concerned' },
    IAAS: { name: 'ROSIE LYNN P. TEJADA', title: 'Unit Head Concerned' },
    IAdS: { name: 'NICKEL JEAN S. LAGARE', title: 'Unit Head Concerned' }
  };

  const includedInstitutes = new Set();
  institutesInRows.forEach(instStr => {
    if (instStr) {
      // Split by comma and "and", then trim
      instStr
        .split(/,| and /i)
        .map(code => code.trim())
        .forEach(code => {
          if (code && signatoryMap[code]) includedInstitutes.add(code);
        });
    }
  });

  // Return signatories in the order of signatoryMap
  return Object.keys(signatoryMap)
    .filter(code => includedInstitutes.has(code))
    .map(code => signatoryMap[code]);
}

function getBase64Image(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.src = url;
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            resolve(canvas.toDataURL('image/png'));
        };
        img.onerror = error => reject(error);
    });
}
